export const GEO_COMPANIES_MUTATION_ADD_ITEMS = 'geo_companies_mutation_add_items'
export const GEO_COMPANIES_MUTATION_ADD_REGION_LOADED = 'geo_companies_mutation_add_region_loaded'

export const GEO_COMPANIES_GETTER_GET_LIST = 'geo_companies_getter_get_list'
export const GEO_COMPANIES_GETTER_GET_REGIONS_LOADED_LIST = 'geo_companies_getter_get_regions_loaded_list'
export const GEO_COMPANIES_GETTER_IS_REGION_LOADED = 'geo_companies_getter_is_region_loaded'

export const GEO_COMPANIES_ACTION_FETCH = 'geo_companies_action_fetch'
